import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { TrailService, ConfigurationsService, LocalesService } from 'core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lms-feature-discovery',
  templateUrl: './feature-discovery.component.html',
  styleUrls: ['./feature-discovery.component.scss']
})
export class FeatureDiscoveryComponent implements OnInit, OnDestroy {
  public features: any[];
  public currentFeature: any;
  private featureIndex = 0;
  private featureTrailSubscription: Subscription = new Subscription();
  private featureTextSubscription: Subscription = new Subscription();

  constructor(
    public cd: ChangeDetectorRef,
    private trailService: TrailService,
    private configurationsService: ConfigurationsService,
    private localesService: LocalesService
  ) {}

  ngOnInit() {
    this.featureTrailSubscription = this.trailService.getFeatureDiscovery$().subscribe((features) => {
      this.features = features;
      this.featureIndex = -1;
      this.setNextFeature();
    });
  }

  setCurrentFeature() {
    if (this.features && this.features.length && this.featureIndex < this.features.length) {
      const currentFeature = this.features[this.featureIndex];
      if (!currentFeature.text) {
        this.featureTextSubscription = this.configurationsService
          .getInfoMessage$(
            'platformMessages',
            'fields.key',
            currentFeature.contentKey.toLowerCase(),
            'text',
            this.localesService.getBrowserLocale(),
            false,
            true
          )
          .subscribe((text) => {
            if (text) {
              currentFeature.text = text;
              this.currentFeature = currentFeature;
              this.cd.detectChanges();
            } else {
              this.setNextFeature();
            }
          });
        return;
      }
      this.currentFeature = currentFeature;
      this.cd.detectChanges();
    } else {
      this.currentFeature = null;
    }
  }

  setNextFeature() {
    this.currentFeature = null;
    this.featureIndex++;
    setTimeout(() => {
      this.setCurrentFeature();
    }, 200);
  }

  public ngOnDestroy() {
    this.featureTrailSubscription.unsubscribe();
    this.featureTextSubscription.unsubscribe();
  }
}
